import axios from 'axios'

const state = () => ({
})

// getters
const getters = {

}

// actions
const actions = {
  sendMailResetPassword: async function ({ state, commit, rootState }, payload) {
    // axios.defaults.headers.common.Authorization = 'Bearer ' + rootState.token
    await axios.post('/api/forgot_passwordIn', { email: payload })
    .then(response => {
      commit('toast/show', { tipo: 'success', messages: ['Correo de notificación enviado.'] }, { root: true })
    }).catch(error => {
      commit('toast/show', { tipo: 'error', messages: [error.response.data.message] }, { root: true })
    })
  },
  getData: async function ({ state, commit, rootState }, payload) {
    commit('loaderOn', 500, { root: true })
    let result = null
    await axios.get(payload.url)
    .then(response => {
      result = response.data
    })
    .finally(function () { commit('loaderOff', null, { root: true }) })
    return result
  },
  postData: async function ({ commit }, payload) {
    commit('setDisableBtn', true, { root: true })
    if (payload.loader !== 'undefined' && payload.loader) { commit('loaderOn', 500, { root: true }) }
    let result = null
    await axios({
      method: 'post',
      url: payload.url,
      data: {
        ...payload.dataForm,
      },
    }).then(response => {
      result = response.data
    }).catch(error => {
      console.log(error)
      return Promise.reject(error)
    }).finally(() => {
      if (payload.loader !== 'undefined' && payload.loader) {
        commit('loaderOff', null, { root: true })
      }
      commit('setDisableBtn', false, { root: true })
    })
    return result
  },
  putData: async function ({ commit }, payload) {
    commit('setDisableBtn', true, { root: true })
    commit('loaderOn', 500, { root: true })
    let result = null
    await axios({
      method: 'put',
      url: payload.url,
      data: {
        ...payload.dataForm,
      },
    }).then(response => {
      result = response.data
    }).catch(error => {
      console.log(error)
      return Promise.reject(error)
    }).finally(() => {
      commit('loaderOff', null, { root: true })
      commit('setDisableBtn', false, { root: true })
    })
    return result
  },
  changeDarkMode: function ({ state, commit }, payload) {
    axios.post('/api/changeDarkMode', { valorActual: payload.valorActual })
  },
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
